import * as React from "react";
import { FunnelContainer } from "ui/funnelContainer/FunnelContainer";
import { makeStyles } from "@material-ui/core";
import { AccountForm } from "components/account/accountForm/AccountForm";
import AdditionnalInformation from "./CollectFunnelAdditionnalInformation";
import { useRouter } from "next/router";
import {
  SET_PERSONNAL_INFORMATIONS,
  SET_DELIVERY_ITEMS,
  STEP_CONFIRMATION_URL,
} from "components/collectFunnel/constants";
import { CollectFunnelContext } from "components/collectFunnel/CollectFunnelProvider";
import * as collectFile from "lib/collectFile";
import { formatCollectData } from "components/collectFunnel/utils/formatData";
import { pushCompleteCollectTransaction, pushGAEvent } from "lib/gtm";
import { CollectFunnelProductsInformationsStep } from "../collectFunnelProductsInformationsStep/CollectFunnelProductsInformationsStep";

const PRODUCT_INFORMATION_STEP = "productInformation";
const PERSONAL_INFORMATION_STEP = "personnalInformation";

export const CollectFunnelInformationStep = () => {
  const [state, dispatch] = React.useContext(CollectFunnelContext);
  const router = useRouter();
  const classes = useStyles();
  const [displayAccountForm, setDisplayAccountForm] = React.useState(true);
  const [error, setError] = React.useState("");
  const [step, setStep] = React.useState(PRODUCT_INFORMATION_STEP);

  const handleNextStep = () => {
    setStep(PERSONAL_INFORMATION_STEP);
  };

  const handlePrevious = () => {
    if (!displayAccountForm) setDisplayAccountForm(true);
    else setStep(PRODUCT_INFORMATION_STEP);
  };

  const handleStorePersonalInfo = React.useCallback(
    (values) => {
      dispatch({
        type: SET_PERSONNAL_INFORMATIONS,
        data: values,
      });
      setDisplayAccountForm(false);
    },
    [dispatch]
  );

  const handleSubmitCollectFile = async (values) => {
    dispatch({
      type: SET_PERSONNAL_INFORMATIONS,
      data: values,
    });
    await collectFile.create(formatCollectData({ ...state, ...values })).then((response) =>
      dispatch({
        type: SET_DELIVERY_ITEMS,
        data: { deliveryItems: response.data },
      })
    );
    if (error) {
      setError("Toutes nos excuses, nous avons rencontré un problème technique, merci de réessayer !");
    } else {
      pushCompleteCollectTransaction(state.products.map((product) => product.type).join(", "));
      router.push(STEP_CONFIRMATION_URL, undefined, { shallow: true });

      // Track email optin
      if (state.hasOptedIn) {
        pushGAEvent("newsletter_subscribe", "Newsletter+Offers", "Collect");
      }
    }
  };

  return (
    <FunnelContainer>
      <div className={classes.formContainer}>
        <>
          {step === PRODUCT_INFORMATION_STEP && (
            <CollectFunnelProductsInformationsStep handleNextStep={handleNextStep} />
          )}
          {step === PERSONAL_INFORMATION_STEP && (
            <>
              {displayAccountForm ? (
                <AccountForm
                  address={state.address}
                  postalCode={state.postalCode}
                  addressDetails={state.addressDetails}
                  firstname={state.firstname}
                  lastname={state.lastname}
                  email={state.email}
                  phone={state.phone}
                  hasOptedIn
                  handleSubmit={handleStorePersonalInfo}
                  handlePrevious={handlePrevious}
                  collectForm
                />
              ) : (
                <AdditionnalInformation
                  handleSubmit={handleSubmitCollectFile}
                  handlePrevious={handlePrevious}
                  address={state.address}
                  full_address={state.address.formatted_address}
                  street={`${
                    state.address.address_components.find((component) => component.types.includes("street_number"))
                      ?.long_name
                  } ${
                    state.address.address_components.find((component) => component.types.includes("route"))?.long_name
                  }`}
                  city={
                    state.address.address_components.find((component) => component.types.includes("locality"))
                      ?.long_name
                  }
                  informations={state.addressDetails}
                  zipcode={
                    state.address.address_components.find((component) => component.types.includes("postal_code"))
                      ?.long_name
                  }
                  isBuilding={state.isBuilding}
                  elevator={state.elevator}
                  floor={state.floor}
                  difficulties={state.difficulties}
                  error={error}
                />
              )}
            </>
          )}
        </>
      </div>
    </FunnelContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  formContainer: {
    padding: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
}));
